export const normalizeDepartmentIDs = (department_ids = []) => {
	if(!Array.isArray(department_ids)) return [];

	return department_ids
		.filter(department_id => department_id !== null && department_id !== undefined && department_id !== '' && department_id !== '0')
		.map(department_id => `${department_id}`);
};

export const userHasCrossDepartmentEditingPermission = (departments = [], userInfo = {}, users = []) => {
	if(!departments || !userInfo) return false;
	if(`${userInfo.allow_cross_department_editing}` === '1') return true;

	const matching_user = Array.isArray(users) ? users.find(user => `${user.user_id}` === `${userInfo.user_id}`) : null;
	if(`${matching_user?.allow_cross_department_editing}` === '1') return true;

	return departments.some(department_info => {
		const supervisors = Array.isArray(department_info.supervisors) ? department_info.supervisors : [];
		return supervisors.some(supervisor_info => `${supervisor_info.user_id}` === `${userInfo.user_id}` && supervisor_info.allow_cross_department_editing === '1');
	});
};

export const userHasManualPlacementPermission = (departments = [], userInfo = {}, departmentID = null) => {
	if(!departments || !userInfo) return false;

	return departments.some(department_info => {
		if(departmentID !== null && `${department_info.department_id}` !== `${departmentID}`) return false;

		const supervisors = Array.isArray(department_info.supervisors) ? department_info.supervisors : [];
		return supervisors.some(supervisor_info => `${supervisor_info.user_id}` === `${userInfo.user_id}` && `${supervisor_info.allow_manual_placements}` === '1');
	});
};

export const userOwnsAnyDepartment = (departments = [], userInfo = {}, department_ids = []) => {
	const normalized_department_ids = normalizeDepartmentIDs(department_ids);
	if(normalized_department_ids.length === 0) return false;

	return departments.some(department_info => {
		if(!normalized_department_ids.includes(`${department_info.department_id}`)) return false;

		const supervisors = Array.isArray(department_info.supervisors) ? department_info.supervisors : [];
		return supervisors.some(supervisor_info => `${supervisor_info.user_id}` === `${userInfo.user_id}`);
	});
};

export const canUserAddExistingDataToDepartment = ({departments = [], userInfo = {}, users = [], userIsAdmin = false, dataDepartments = []} = {}) => {
	if(userIsAdmin) return true;
	if(`${userInfo.role_id}` !== '3') return true;
	if(userHasCrossDepartmentEditingPermission(departments, userInfo, users)) return true;

	const normalized_data_departments = normalizeDepartmentIDs(dataDepartments);
	if(normalized_data_departments.length === 0) return true;

	return userOwnsAnyDepartment(departments, userInfo, normalized_data_departments);
};

export const canUserUseExistingDataInSection = ({departments = [], userInfo = {}, users = [], userIsAdmin = false, dataDepartments = []} = {}) => {
	if(userIsAdmin) return true;
	if(`${userInfo.role_id}` !== '3') return true;
	if(userHasCrossDepartmentEditingPermission(departments, userInfo, users)) return true;

	const normalized_data_departments = normalizeDepartmentIDs(dataDepartments);
	if(normalized_data_departments.length === 0) return false;

	return userOwnsAnyDepartment(departments, userInfo, normalized_data_departments);
};
